import { GcpRequestData } from '../../../../../../store/uploadStore';

const isRinexArchive = (filename: string) => filename.toLowerCase().endsWith('.zip');

export const isMissingRinexArchive = (gcpRequest: GcpRequestData) => {
  const uploads = gcpRequest.measurementUploads;
  const uploadedUrls = new Set(uploads.map((u) => u.uploadedUrl));

  // Saved files come without a filename, so we can't tell whether one of them is a ZIP.
  const hasSavedFiles = gcpRequest.measurements.some((url) => !uploadedUrls.has(url));

  return uploads.length > 0 && !hasSavedFiles && !uploads.some((u) => isRinexArchive(u.file.name));
};
